import {
  Box,
  Button,
  Card,
  Container,
  Flex,
  Grid,
  Group,
  PasswordInput,
  TextInput,
  Title,
  useMantineTheme,
} from "@mantine/core";
import React, { useEffect } from "react";
import CardHeader from "../../components/CardHeader";
import useAuthStore from "../../store/useAuthStore";
import { useForm } from "@mantine/form";
import axios from "axios";
import { toast } from "react-hot-toast";
import { modals } from "@mantine/modals";
import ListRow from "../../components/ListRow";
import dayjs from "dayjs";
import AddressFinder from "@/components/AddressFinder";

export default function Company() {
  const user = useAuthStore((state) => state.user);

  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      username: "",
      phoneNumber: "",

      address: "",
      lat: "",
      lng: "",
      businessNumber: "",
      ceoName: "",
    },
  });

  useEffect(() => {
    if (!user) return;
    form.setValues({
      name: user?.company?.name || "",
      address: user?.company?.address || "",
      lat: user?.company?.lat || "",
      lng: user?.company?.lng || "",
      businessNumber: user?.company?.businessNumber || "",
      ceoName: user?.company?.ceoName || "",
    });
  }, [user]);

  async function handleSubmit(val) {
    await axios({
      url: "/companies/" + user?.company?.id,
      method: "PUT",
      data: {
        data: {
          name: val.name,
          address: val.address,
          lat: val.lat,
          lng: val.lng,
          businessNumber: val.businessNumber,
          ceoName: val.ceoName,
        },
      },
    });

    toast.success("회사 정보가 업데이트 되었습니다");
  }

  async function handleResetPassword() {
    const handleModalSubmit = async (e) => {
      e.preventDefault();
      // get password from event e
      const password = e.target.password.value;
      const rePassword = e.target["re-password"].value;
      if (password !== rePassword) {
        toast.error("비밀번호가 일치하지 않습니다");
        return;
      }

      await axios({
        url: "/users/" + user.id,
        method: "PUT",
        data: {
          password,
        },
      });
      toast.success("비밀번호가 수정되었습니다");
      modals.closeAll();
    };

    modals.open({
      title: "비밀번호 초기화",
      zIndex: 10000,
      children: (
        <>
          <form onSubmit={handleModalSubmit}>
            <PasswordInput
              required
              label="신규 비밀번호"
              placeholder="신규 비밀번호를 입력해주세요"
              name="password"
              data-autofocus
              mb="sm"
            />
            <PasswordInput
              required
              label="신규 비밀번호 확인"
              placeholder="신규 비밀번호를 다시 입력해주세요"
              name="re-password"
              mb="sm"
            />

            <Flex justify="flex-end" mt="lg">
              <Button type="submit">비밀번호 초기화</Button>
            </Flex>
          </form>
        </>
      ),
    });
  }

  async function handleDeleteAccount() {
    alert("todo");
  }

  return (
    <Container>
      <Grid>
        <Grid.Col xs={12} md={8}>
          <Card>
            <form onSubmit={form.onSubmit(handleSubmit)}>
              <CardHeader title="회사 정보" />
              <MypageItem title="업체명">
                <TextInput mb={0} placeholder="업체명" {...form.getInputProps("name")} />
              </MypageItem>
              <MypageItem title="주소">
                <AddressFinder
                  title="업체 주소"
                  noLabel
                  address={form.values.address}
                  setAddress={(value) => form.setFieldValue("address", value)}
                  setLat={(value) => form.setFieldValue("lat", value)}
                  setLng={(value) => form.setFieldValue("lng", value)}
                />
              </MypageItem>
              <MypageItem title="사업자 번호">
                <TextInput mb={0} placeholder="사업자 번호" {...form.getInputProps("businessNumber")} />
              </MypageItem>
              <MypageItem title="대표자명">
                <TextInput mb={0} placeholder="대표자명" {...form.getInputProps("ceoName")} />
              </MypageItem>
              <MypageItem title="전화번호">
                <TextInput mb={0} placeholder="전화번호" {...form.getInputProps("phoneNumber")} />
              </MypageItem>

              <Flex justify="flex-end" mt="md">
                <Button type="submit">회사 정보 업데이트</Button>
              </Flex>
            </form>
          </Card>

          {/* <Card mt="lg">
            <CardHeader title="비밀번호 & 보안" />
            <Grid>
              <Grid.Col xs={12} md={6}>
                <Card shadow={0}>
                  <Group position="left" spacing="xs">
                    <IconLockAccess />
                    <Title order={5}>비밀번호 초기화</Title>
                  </Group>
                  <Text size="sm" mt="sm" color="dimmed">
                    기존의 비밀번호는 암호화되어 확인 및 복구가 불가능합니다. 비밀번호를 초기화하여 새로운 비밀번호를
                    설정할 수 있습니다.
                  </Text>
                  <Flex justify="flex-end" mt="sm">
                    <Button color="red" onClick={handleResetPassword}>
                      비밀번호 초기화
                    </Button>
                  </Flex>
                </Card>
              </Grid.Col>

              <Grid.Col xs={12} md={6}>
                <Card shadow={0}>
                  <Group position="left" spacing="xs">
                    <IconSquareRoundedX />
                    <Title order={5}>회원 탈퇴</Title>
                  </Group>
                  <Text size="sm" mt="sm" color="dimmed">
                    회원 탈퇴를 하시면 기존의 모든 데이터는 영구히 삭제되며 복구가 불가능합니다.
                  </Text>
                  <Flex justify="flex-end" mt="sm">
                    <Button color="red" disabled onClick={handleDeleteAccount}>
                      회원 탈퇴
                    </Button>
                  </Flex>
                </Card>
              </Grid.Col>
            </Grid>
          </Card> */}
        </Grid.Col>

        <Grid.Col xs={12} md={4}>
          <Card>
            <Group mb="xl" ml="sm">
              <Flex align="flex-end">
                <Title color="brand" order={2}>
                  {user.name}님,
                </Title>
                <Title order={3} ml={2}>
                  반갑습니다
                </Title>
              </Flex>
            </Group>
            <Box mx="sm">
              {/* <ListRow cat="누적 거래 건수" val={user.username} /> */}
              {/* <ListRow cat="미정산 금액" val={USER_PERMISSION.find((x) => x.value === user.permission)?.label} /> */}
              {/* <ListRow cat="담당자 명수" val={USER_PERMISSION.find((x) => x.value === user.permission)?.label} /> */}
              <ListRow cat="가입일" val={dayjs(user.createdAt).format("YYYY-MM-DD")} />
              <ListRow cat="플랫폼 버전" isLast val={"ver 1.5"} />
            </Box>
          </Card>
        </Grid.Col>
      </Grid>
    </Container>
  );
}

const MypageItem = ({ title, children, icon }) => {
  return (
    <Group mt="lg">
      {/* <Flex sx={{ flex: 1 }} gap="xs"> */}
      {/* <ThemeIcon variant="default">{icon}</ThemeIcon> */}
      <Title sx={{ flex: 1 }} order={5} fw={500}>
        {title}
      </Title>
      {/* </Flex> */}
      <Box sx={{ flex: 3 }}>{children}</Box>
    </Group>
  );
};
